var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h3", [_vm._v("Use Codes Reports")]),
    _vm._v(" "),
    _c("form", { staticClass: "form-inline" }, [
      _c("div", { staticClass: "form-group" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.reportType,
                expression: "reportType"
              }
            ],
            staticClass: "form-control",
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.reportType = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c("option", { attrs: { value: "" } }),
            _vm._v(" "),
            _c("option", { attrs: { value: "active" } }, [
              _vm._v("Active codes")
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "expired" } }, [
              _vm._v("Expired codes")
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "all" } }, [
              _vm._v("Active and expired codes")
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.fetchReport.apply(null, arguments)
            }
          }
        },
        [_vm._v("Fetch Report")]
      )
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _vm.loading
      ? _c("p", { staticClass: "lead text-muted" }, [
          _c("i", { staticClass: "fa fa-circle-o-notch fa-spin" }),
          _vm._v(" Loading...")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.useCodes
      ? _c(
          "div",
          { staticClass: "report-container" },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-4" }, [
                _c("div", { staticClass: "panel panel-default" }, [
                  _c("div", { staticClass: "panel-body text-center" }, [
                    _c("h1", [_vm._v(_vm._s(_vm.useCodes.length))]),
                    _vm._v(" "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v("codes generated")
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-4" }, [
                _c("div", { staticClass: "panel panel-default" }, [
                  _c("div", { staticClass: "panel-body text-center" }, [
                    _c("h1", [_vm._v(_vm._s(_vm.numCodesUsed))]),
                    _vm._v(" "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v("codes used")
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-4" }, [
                _c("div", { staticClass: "panel panel-default" }, [
                  _c("div", { staticClass: "panel-body text-center" }, [
                    _c("h1", [_vm._v(_vm._s(_vm.percentageCodesUsed))]),
                    _vm._v(" "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v("usage")
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-9" }, [
                _c("h4", [_vm._v("Magic Link Destination")]),
                _vm._v(" "),
                _c("div", { staticClass: "radio" }, [
                  _c("label", { attrs: { for: "toolkit" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.magicLinkShortcut,
                          expression: "magicLinkShortcut"
                        }
                      ],
                      attrs: { type: "radio", value: "toolkit", id: "toolkit" },
                      domProps: {
                        checked: _vm._q(_vm.magicLinkShortcut, "toolkit")
                      },
                      on: {
                        change: function($event) {
                          _vm.magicLinkShortcut = "toolkit"
                        }
                      }
                    }),
                    _vm._v(" Toolkit Home\n          ")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "radio" }, [
                  _c("label", { attrs: { for: "pathways" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.magicLinkShortcut,
                          expression: "magicLinkShortcut"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        value: "pathways",
                        id: "pathways"
                      },
                      domProps: {
                        checked: _vm._q(_vm.magicLinkShortcut, "pathways")
                      },
                      on: {
                        change: function($event) {
                          _vm.magicLinkShortcut = "pathways"
                        }
                      }
                    }),
                    _vm._v(" Pathways Home\n          ")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "radio" }, [
                  _c("label", { attrs: { for: "other" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.magicLinkShortcut,
                          expression: "magicLinkShortcut"
                        }
                      ],
                      attrs: { type: "radio", value: "", id: "other" },
                      domProps: { checked: _vm._q(_vm.magicLinkShortcut, "") },
                      on: {
                        change: function($event) {
                          _vm.magicLinkShortcut = ""
                        }
                      }
                    }),
                    _vm._v(" Other URL\n          ")
                  ]),
                  _vm._v(" "),
                  _vm.magicLinkShortcut === ""
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.magicLinkDestination,
                            expression: "magicLinkDestination"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          value: "https://goalbookapp.com/toolkit",
                          placeholder: "URL"
                        },
                        domProps: { value: _vm.magicLinkDestination },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.magicLinkDestination = $event.target.value
                          }
                        }
                      })
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-3" },
                [
                  _c("ExportToCSVButton", {
                    staticClass: "btn btn-block btn-primary",
                    attrs: {
                      label: "Export Magic Links",
                      filename: "magiclinks.csv",
                      headers: _vm.csvExportData.headers,
                      rows: _vm.csvExportData.rows
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm.loadingReportTable
              ? _c("p", { staticClass: "text-muted" }, [
                  _c("i", { staticClass: "fa fa-circle-o-notch fa-spin" }),
                  _vm._v(" Loading user table...")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("v-client-table", {
              attrs: {
                columns: _vm.tableColumns,
                data: _vm.tableRows,
                options: _vm.tableOptions
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "name",
                    fn: function(props) {
                      return _c("div", {}, [
                        _vm._v(
                          "\n        " + _vm._s(props.row.name) + "\n        "
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(props.row.user_uuid))
                        ])
                      ])
                    }
                  },
                  {
                    key: "date_generated",
                    fn: function(props) {
                      return _c("div", {}, [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.formatTimestamp(
                                props.row.date_generated,
                                "M/D/YY, h:mm a z"
                              )
                            ) +
                            "\n        "
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(props.row.uuid))
                        ])
                      ])
                    }
                  },
                  {
                    key: "expiration_date",
                    fn: function(props) {
                      return _c("div", {}, [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.formatTimestamp(
                                props.row.expiration_date,
                                "M/D/YY"
                              )
                            ) +
                            "\n        "
                        ),
                        _vm.isDatePassed(props.row.expiration_date)
                          ? _c("span", { staticClass: "label label-warning" }, [
                              _vm._v("Expired")
                            ])
                          : _vm._e()
                      ])
                    }
                  },
                  {
                    key: "used",
                    fn: function(props) {
                      return _c("span", {}, [
                        _vm._v(
                          _vm._s(
                            (props.row.used &&
                              _vm.formatTimestamp(
                                props.row.used,
                                "M/D/YY, h:mm a z"
                              )) ||
                              "-"
                          )
                        )
                      ])
                    }
                  },
                  {
                    key: "test",
                    fn: function(props) {
                      return _c(
                        "button",
                        {
                          staticClass: "btn btn-default btn-xs",
                          attrs: {
                            disabled:
                              !_vm.magicLinkShortcut &&
                              !_vm.magicLinkDestination
                          },
                          on: {
                            click: function($event) {
                              return _vm.testUseCode(props.row.uuid)
                            }
                          }
                        },
                        [_vm._v("Test")]
                      )
                    }
                  }
                ],
                null,
                false,
                1424366385
              )
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }